import { jsxs as y, jsx as r, Fragment as oe } from "react/jsx-runtime";
import { useState as V, useCallback as U, useEffect as j, createElement as H, Fragment as se, useRef as S, useMemo as le } from "react";
import { Serializer as X, Question as Z, Model as ce } from "survey-core";
import "survey-core/survey.i18n";
import { ReactQuestionFactory as ee, SurveyQuestionElementBase as te, Survey as ue } from "survey-react-ui";
import "survey-core/survey-core.min.css";
const Y = {
  en: {
    submitButton: "Submit",
    submitting: "Submitting…",
    submitNetworkError: "We could not confirm that your answers were sent. Your answers are still here — please check your connection and press Submit again.",
    submitServerError: "Something went wrong and your answers were not sent. Your answers are still here — please press Submit again.",
    submitAlreadyCompleted: "This survey has already been completed.",
    addSubject: "+ Add",
    removeSubject: "Remove",
    subjectPlaceholder: "Name",
    textPlaceholder: "Testimonial",
    subjectValidationError: "Please fill in both the name and the testimonial for each entry.",
    resetRating: "Reset",
    rangeLabels: ["Not good", "Good", "Great", "Excellent", "Exceptional"],
    submittedTitle: "Thank you for taking part in Legal500 research.",
    submittedDescription: "",
    submittedMoreFeedback: "Thank you for completing this survey. If you would like to share any additional feedback with us about this or any other firm you have used, please click {link} to complete another survey.",
    submittedMoreFeedbackLink: "this link",
    barristerIntro: "{barristerName} of {firmName} has put forward your name to give a testimonial for them on their {practiceArea} practice."
  },
  es: {
    submitButton: "Enviar",
    submitting: "Enviando…",
    submitNetworkError: "No hemos podido confirmar el envío de sus respuestas. Sus respuestas se conservan: compruebe su conexión y vuelva a pulsar Enviar.",
    submitServerError: "Se ha producido un error y sus respuestas no se han enviado. Sus respuestas se conservan: vuelva a pulsar Enviar.",
    submitAlreadyCompleted: "Esta encuesta ya ha sido completada.",
    addSubject: "+ Agregar",
    removeSubject: "Eliminar",
    subjectPlaceholder: "Nombre",
    textPlaceholder: "Testimonio",
    subjectValidationError: "Por favor, complete tanto el nombre como el testimonio de cada entrada.",
    resetRating: "Restablecer",
    rangeLabels: ["No bueno", "Bueno", "Muy bueno", "Excelente", "Excepcional"],
    submittedTitle: "Gracias por participar en la investigación de Legal500.",
    submittedDescription: "",
    submittedMoreFeedback: "Gracias por completar esta encuesta. Si desea compartir con nosotros cualquier comentario adicional sobre este o cualquier otro despacho con el que haya trabajado, haga clic en {link} para completar otra encuesta.",
    submittedMoreFeedbackLink: "este enlace",
    barristerIntro: "{barristerName} de {firmName} ha propuesto su nombre para que dé un testimonio sobre su práctica en {practiceArea}."
  },
  fr: {
    submitButton: "Soumettre",
    submitting: "Envoi en cours…",
    submitNetworkError: "Nous n'avons pas pu confirmer l'envoi de vos réponses. Vos réponses sont conservées : vérifiez votre connexion et cliquez de nouveau sur Soumettre.",
    submitServerError: "Une erreur s'est produite et vos réponses n'ont pas été envoyées. Vos réponses sont conservées : cliquez de nouveau sur Soumettre.",
    submitAlreadyCompleted: "Ce questionnaire a déjà été complété.",
    addSubject: "+ Ajouter",
    removeSubject: "Supprimer",
    subjectPlaceholder: "Nom",
    textPlaceholder: "Témoignage",
    subjectValidationError: "Veuillez remplir à la fois le nom et le témoignage pour chaque entrée.",
    resetRating: "Réinitialiser",
    rangeLabels: ["Pas bon", "Bon", "Très bon", "Excellent", "Exceptionnel"],
    submittedTitle: "Merci d'avoir participé à la recherche Legal500.",
    submittedDescription: "",
    submittedMoreFeedback: "Merci d'avoir complété ce questionnaire. Si vous souhaitez nous faire part de commentaires supplémentaires sur ce cabinet ou sur tout autre cabinet auquel vous avez fait appel, veuillez cliquer sur {link} pour remplir un autre questionnaire.",
    submittedMoreFeedbackLink: "ce lien",
    barristerIntro: "{barristerName} de {firmName} a proposé votre nom afin que vous donniez un témoignage sur sa pratique en {practiceArea}."
  },
  de: {
    submitButton: "Absenden",
    submitting: "Wird gesendet…",
    submitNetworkError: "Wir konnten nicht bestätigen, dass Ihre Antworten gesendet wurden. Ihre Antworten bleiben erhalten – bitte prüfen Sie Ihre Verbindung und klicken Sie erneut auf Absenden.",
    submitServerError: "Es ist ein Fehler aufgetreten und Ihre Antworten wurden nicht gesendet. Ihre Antworten bleiben erhalten – bitte klicken Sie erneut auf Absenden.",
    submitAlreadyCompleted: "Diese Umfrage wurde bereits ausgefüllt.",
    addSubject: "+ Hinzufügen",
    removeSubject: "Entfernen",
    subjectPlaceholder: "Name",
    textPlaceholder: "Erfahrungsbericht",
    subjectValidationError: "Bitte füllen Sie für jeden Eintrag sowohl den Namen als auch den Erfahrungsbericht aus.",
    resetRating: "Zurücksetzen",
    rangeLabels: ["Nicht gut", "Gut", "Sehr gut", "Ausgezeichnet", "Außergewöhnlich"],
    submittedTitle: "Vielen Dank für Ihre Teilnahme an der Legal500-Forschung.",
    submittedDescription: "",
    submittedMoreFeedback: "Vielen Dank, dass Sie diese Umfrage ausgefüllt haben. Wenn Sie uns weiteres Feedback zu dieser oder einer anderen Kanzlei geben möchten, mit der Sie zusammengearbeitet haben, klicken Sie bitte auf {link}, um eine weitere Umfrage auszufüllen.",
    submittedMoreFeedbackLink: "diesen Link",
    barristerIntro: "{barristerName} von {firmName} hat Ihren Namen angegeben, damit Sie ein Testimonial zur Tätigkeit im Bereich {practiceArea} abgeben."
  },
  "zh-cn": {
    submitButton: "提交",
    submitting: "正在提交…",
    submitNetworkError: "我们无法确认您的回答是否已发送。您的回答仍保留在此页面上，请检查网络连接后再次点击“提交”。",
    submitServerError: "出现错误，您的回答未能发送。您的回答仍保留在此页面上，请再次点击“提交”。",
    submitAlreadyCompleted: "此调查已完成。",
    addSubject: "+ 添加",
    removeSubject: "删除",
    subjectPlaceholder: "姓名",
    textPlaceholder: "评价",
    subjectValidationError: "请为每个条目填写姓名和评价。",
    resetRating: "重置",
    rangeLabels: ["不好", "好", "很好", "优秀", "卓越"],
    submittedTitle: "感谢您参与 Legal500 调研。",
    submittedDescription: "",
    submittedMoreFeedback: "感谢您完成本次调查。如果您希望就本律所或您合作过的任何其他律所向我们提供更多反馈，请点击{link}填写另一份调查。",
    submittedMoreFeedbackLink: "此链接",
    barristerIntro: "{firmName} 的 {barristerName} 推荐您为其在 {practiceArea} 领域的业务提供推荐评价。"
  },
  pt: {
    submitButton: "Enviar",
    submitting: "A enviar…",
    submitNetworkError: "Não foi possível confirmar o envio das suas respostas. As suas respostas foram mantidas: verifique a sua ligação e clique novamente em Enviar.",
    submitServerError: "Ocorreu um erro e as suas respostas não foram enviadas. As suas respostas foram mantidas: clique novamente em Enviar.",
    submitAlreadyCompleted: "Este inquérito já foi preenchido.",
    addSubject: "+ Adicionar",
    removeSubject: "Remover",
    subjectPlaceholder: "Nome",
    textPlaceholder: "Depoimento",
    subjectValidationError: "Por favor, preencha o nome e o depoimento para cada entrada.",
    resetRating: "Redefinir",
    rangeLabels: ["Não bom", "Bom", "Muito bom", "Excelente", "Excepcional"],
    submittedTitle: "Obrigado por participar na investigação da Legal500.",
    submittedDescription: "",
    submittedMoreFeedback: "Obrigado por preencher este inquérito. Se quiser partilhar connosco qualquer comentário adicional sobre esta ou qualquer outra sociedade de advogados com que tenha trabalhado, clique {link} para preencher outro inquérito.",
    submittedMoreFeedbackLink: "nesta ligação",
    barristerIntro: "{barristerName} de {firmName} indicou o seu nome para que dê um testemunho sobre a sua prática em {practiceArea}."
  },
  pl: {
    submitButton: "Wyślij",
    submitting: "Wysyłanie…",
    submitNetworkError: "Nie udało się potwierdzić wysłania odpowiedzi. Odpowiedzi zostały zachowane — proszę sprawdzić połączenie i ponownie kliknąć Wyślij.",
    submitServerError: "Wystąpił błąd i odpowiedzi nie zostały wysłane. Odpowiedzi zostały zachowane — proszę ponownie kliknąć Wyślij.",
    submitAlreadyCompleted: "Ta ankieta została już wypełniona.",
    addSubject: "+ Dodaj",
    removeSubject: "Usuń",
    subjectPlaceholder: "Imię i nazwisko",
    textPlaceholder: "Opinia",
    subjectValidationError: "Proszę wypełnić zarówno imię i nazwisko, jak i opinię dla każdego wpisu.",
    resetRating: "Resetuj",
    rangeLabels: ["Słabe", "Dobre", "Bardzo dobre", "Doskonałe", "Wyjątkowe"],
    submittedTitle: "Dziękujemy za udział w badaniach Legal500.",
    submittedDescription: "",
    submittedMoreFeedback: "Dziękujemy za wypełnienie tej ankiety. Jeśli chcą Państwo przekazać nam dodatkowe uwagi na temat tej lub innej kancelarii, z której usług Państwo korzystali, prosimy kliknąć {link}, aby wypełnić kolejną ankietę.",
    submittedMoreFeedbackLink: "ten link",
    barristerIntro: "{barristerName} z {firmName} wskazał(a) Państwa jako osobę, która może wystawić opinię o jego/jej praktyce w dziedzinie {practiceArea}."
  },
  it: {
    submitButton: "Invia",
    submitting: "Invio in corso…",
    submitNetworkError: "Non è stato possibile confermare l'invio delle sue risposte. Le risposte sono state conservate: verifichi la connessione e prema di nuovo Invia.",
    submitServerError: "Si è verificato un errore e le sue risposte non sono state inviate. Le risposte sono state conservate: prema di nuovo Invia.",
    submitAlreadyCompleted: "Questo sondaggio è già stato completato.",
    addSubject: "+ Aggiungi",
    removeSubject: "Rimuovi",
    subjectPlaceholder: "Nome",
    textPlaceholder: "Testimonianza",
    subjectValidationError: "Si prega di compilare il nome e la testimonianza per ogni voce.",
    resetRating: "Reimposta",
    rangeLabels: ["Non buono", "Buono", "Molto buono", "Eccellente", "Eccezionale"],
    submittedTitle: "Grazie per aver partecipato alla ricerca Legal500.",
    submittedDescription: "",
    submittedMoreFeedback: "Grazie per aver completato questo sondaggio. Se desidera condividere con noi ulteriori commenti su questo o su qualsiasi altro studio legale di cui si è avvalso, clicchi su {link} per completare un altro sondaggio.",
    submittedMoreFeedbackLink: "questo link",
    barristerIntro: "{barristerName} di {firmName} ha proposto il suo nome per fornire una testimonianza sulla sua attività nel settore {practiceArea}."
  },
  nl: {
    submitButton: "Verzenden",
    submitting: "Bezig met verzenden…",
    submitNetworkError: "We konden niet bevestigen dat uw antwoorden zijn verzonden. Uw antwoorden zijn bewaard — controleer uw verbinding en klik nogmaals op Verzenden.",
    submitServerError: "Er is iets misgegaan en uw antwoorden zijn niet verzonden. Uw antwoorden zijn bewaard — klik nogmaals op Verzenden.",
    submitAlreadyCompleted: "Deze enquête is al ingevuld.",
    addSubject: "+ Toevoegen",
    removeSubject: "Verwijderen",
    subjectPlaceholder: "Naam",
    textPlaceholder: "Getuigenis",
    subjectValidationError: "Vul voor elke invoer zowel de naam als de getuigenis in.",
    resetRating: "Resetten",
    rangeLabels: ["Niet goed", "Goed", "Zeer goed", "Uitstekend", "Uitzonderlijk"],
    submittedTitle: "Bedankt voor uw deelname aan het Legal500-onderzoek.",
    submittedDescription: "",
    submittedMoreFeedback: "Bedankt voor het invullen van deze enquête. Als u ons aanvullende feedback wilt geven over dit of een ander kantoor waarmee u hebt gewerkt, klik dan op {link} om nog een enquête in te vullen.",
    submittedMoreFeedbackLink: "deze link",
    barristerIntro: "{barristerName} van {firmName} heeft uw naam voorgedragen om een getuigenis te geven over zijn of haar praktijk op het gebied van {practiceArea}."
  }
};
function w(e) {
  return Y[e] ?? Y.en;
}
const J = "no_experience";
function de({ question: e }) {
  const [, t] = V(0), n = U(() => t((c) => c + 1), []);
  j(() => {
    const c = e.survey, p = "range-slider-internal-value";
    return e.registerFunctionOnPropertiesValueChanged(["value", "readOnly"], n, p), c?.onLocaleChangedEvent.add(n), () => {
      e.unRegisterFunctionOnPropertiesValueChanged(["value", "readOnly"], p), c?.onLocaleChangedEvent.remove(n);
    };
  }, [e, n]);
  const i = e.rateMin ?? 0, d = e.rateMax ?? 10, u = e.value, l = u === J, m = u == null || u === "" ? Number.NaN : Number(u), g = Number.isFinite(m), _ = g ? m : i, v = d - i, o = v > 0 ? (_ - i) / v * 100 : 0, s = Array.isArray(e.rangeLabels) ? [...e.rangeLabels].sort((c, p) => c.order - p.order) : [], N = s.length > 0 ? v / s.length : 0, b = s.length > 0 && v > 0 ? Math.min(Math.floor((_ - i) / N), s.length - 1) : 0, B = e.survey?.locale ?? "", G = B.split("-")[0], A = (c) => c[B]?.trim() || c[G]?.trim() || c.default?.trim() || "", D = (c) => A(c.label), f = e.noExperienceLabel ? A(e.noExperienceLabel) : "", L = `${e.id}-no-experience`, E = e.isReadOnly;
  j(() => {
    l && !f && (e.value = void 0);
  }, [l, f, e]);
  const O = (c) => {
    if (g || l || E) return;
    const p = c.currentTarget.getBoundingClientRect(), R = c.clientX - p.left, a = Math.max(0, Math.min(1, R / p.width));
    e.value = Math.round(i + a * v);
  }, q = () => {
    e.value = void 0;
  }, $ = (c) => {
    e.value = c.target.checked ? J : void 0;
  }, M = `l500-range-slider__track ${l ? "l500-range-slider__track--disabled" : g || E ? "l500-range-slider__track--locked" : "l500-range-slider__track--clickable"}`;
  return /* @__PURE__ */ y("div", { className: "l500-range-slider__container", children: [
    (g || l) && /* @__PURE__ */ r("div", { className: "l500-range-slider__reset-row", children: /* @__PURE__ */ r(
      "button",
      {
        type: "button",
        className: "l500-range-slider__reset-btn",
        disabled: E,
        onClick: q,
        children: w(B).resetRating
      }
    ) }),
    /* @__PURE__ */ r("div", { className: M, onClick: O, children: /* @__PURE__ */ r(
      "input",
      {
        type: "range",
        className: `l500-range-slider${g ? "" : " l500-range-slider--unselected"}`,
        min: i,
        max: d,
        step: 1,
        value: _,
        disabled: l || E,
        onChange: (c) => {
          e.value = Number(c.target.value);
        },
        "aria-label": e.title,
        "aria-valuemin": i,
        "aria-valuemax": d,
        "aria-valuenow": g ? _ : void 0,
        style: {
          background: g ? `linear-gradient(to right, var(--l500-accent-color) 0%, var(--l500-accent-color) ${o}%, var(--l500-grey-220) ${o}%, var(--l500-grey-220) 100%)` : void 0,
          pointerEvents: g ? "auto" : "none"
        }
      }
    ) }),
    s.length > 0 && /* @__PURE__ */ r("div", { className: "l500-range-slider__labels", children: s.map((c, p) => /* @__PURE__ */ r("span", { className: `l500-range-slider__label ${g && p === b ? "l500-range-slider__label--active" : "l500-range-slider__label--inactive"}`, children: D(c) }, c.id)) }),
    f && /* @__PURE__ */ y("div", { className: "l500-range-slider__no-experience", children: [
      /* @__PURE__ */ r(
        "input",
        {
          type: "checkbox",
          id: L,
          className: "l500-range-slider__no-experience-input",
          checked: l,
          disabled: E,
          onChange: $
        }
      ),
      /* @__PURE__ */ r("label", { htmlFor: L, className: "l500-range-slider__no-experience-label", children: f })
    ] })
  ] });
}
function me({ question: e }) {
  const t = e.rateMin ?? 0, n = e.rateMax ?? 10, i = e.name, d = !!e.isReadOnly, [, u] = V(0), l = U(() => u((o) => o + 1), []);
  j(() => {
    const o = e.survey, s = "numeric-radio-choice-value";
    return e.registerFunctionOnPropertyValueChanged("value", l, s), o?.onLocaleChangedEvent.add(l), () => {
      e.unRegisterFunctionOnPropertyValueChanged("value", s), o?.onLocaleChangedEvent.remove(l);
    };
  }, [e, l]);
  const m = e.value, g = m == null || m === "" ? void 0 : typeof m == "number" ? m : Number(m), _ = [];
  if (n >= t)
    for (let o = t; o <= n; o += 1) _.push(o);
  const v = (o) => (s) => {
    s.target.checked && (e.value = o);
  };
  return /* @__PURE__ */ r("fieldset", { className: "numeric-radio-choice", children: /* @__PURE__ */ r("ul", { className: "numeric-radio-choice__list", role: "radiogroup", children: _.map((o) => {
    const s = `${i}-${o}`;
    return /* @__PURE__ */ y("li", { className: "numeric-radio-choice__item", children: [
      /* @__PURE__ */ r(
        "input",
        {
          type: "radio",
          id: s,
          className: "numeric-radio-choice__input",
          name: i,
          value: o,
          checked: g === o,
          disabled: d,
          onChange: v(o)
        }
      ),
      /* @__PURE__ */ r("label", { htmlFor: s, className: "numeric-radio-choice__label", children: o })
    ] }, o);
  }) }) });
}
class be extends Z {
  getType() {
    return "range";
  }
}
X.addClass(
  "range",
  [
    { name: "rateMin:number", default: 0 },
    { name: "rateMax:number", default: 10 },
    { name: "rangeLabels", default: [] },
    { name: "libraryQuestionType:string", default: "" },
    { name: "noExperienceLabel", default: null }
  ],
  () => new be(""),
  "question"
);
class pe extends te {
  get question() {
    return this.questionBase;
  }
  renderElement() {
    const t = this.question;
    return t.libraryQuestionType === "range-10" ? /* @__PURE__ */ r(me, { question: t }) : /* @__PURE__ */ r(de, { question: t });
  }
}
function ge() {
  ee.Instance.registerQuestion("range", (e) => H(pe, e));
}
function re(e) {
  return e.subject.trim() !== "" || e.text.trim() !== "";
}
function ne(e) {
  const t = e.subject.trim() !== "", n = e.text.trim() !== "";
  return t !== n;
}
function he(e) {
  return e.reduce(
    (n, i) => typeof i.position == "number" && i.position > n ? i.position : n,
    0
  ) + 1;
}
class ve extends Z {
  getType() {
    return "multi-testimonial";
  }
  isValueEmpty() {
    return Array.isArray(this.value) ? !this.value.some(re) : !0;
  }
}
X.addClass(
  "multi-testimonial",
  [{ name: "subjectLabel", default: { default: "Lawyer" } }],
  () => new ve(""),
  "question"
);
function fe(e) {
  return ne(e) ? {
    subject: e.subject.trim() === "",
    text: e.text.trim() === ""
  } : null;
}
function ke(e, t) {
  if (!Array.isArray(e)) return null;
  const n = e.filter(re);
  return n.length === 0 ? null : n.some(ne) ? w(t).subjectValidationError : null;
}
const ye = "Add Lawyer";
function _e(e, t) {
  return (e?.[t] ?? e?.default ?? "").trim() || ye;
}
class Ne extends te {
  get question() {
    return this.questionBase;
  }
  getEntries() {
    const t = this.question.value;
    return Array.isArray(t) ? t : [];
  }
  setEntries(t) {
    this.question.value = t.length > 0 ? [...t] : void 0;
  }
  renderElement() {
    const t = this.getEntries(), n = this.question.errors.length > 0, i = this.question.survey.locale, d = w(i), u = _e(this.question.subjectLabel, i), l = `+ ${u}`, m = u, g = () => {
      this.setEntries([...t, { position: he(t), subject: "", text: "" }]);
    }, _ = (o) => {
      this.setEntries(t.filter((s, N) => N !== o));
    }, v = (o, s, N) => {
      this.setEntries(
        t.map((b, F) => F === o ? { ...b, [s]: N } : b)
      );
    };
    return /* @__PURE__ */ y("div", { className: "l500-multi-testimonial", children: [
      t.map((o, s) => {
        const N = n ? fe(o) : null;
        return /* @__PURE__ */ y(
          "div",
          {
            className: `l500-multi-testimonial__entry${N ? " l500-multi-testimonial__entry--error" : ""}`,
            children: [
              /* @__PURE__ */ r("div", { className: "l500-multi-testimonial__entry-header", children: /* @__PURE__ */ r(
                "button",
                {
                  type: "button",
                  className: "l500-multi-testimonial__remove-btn",
                  onClick: () => _(s),
                  children: d.removeSubject
                }
              ) }),
              /* @__PURE__ */ r(
                "input",
                {
                  type: "text",
                  placeholder: d.subjectPlaceholder,
                  "aria-label": m,
                  value: o.subject,
                  onChange: (b) => v(s, "subject", b.target.value),
                  className: `l500-multi-testimonial__input${N?.subject ? " l500-multi-testimonial__input--error" : ""}`
                }
              ),
              /* @__PURE__ */ r(
                "textarea",
                {
                  placeholder: d.textPlaceholder,
                  value: o.text,
                  onChange: (b) => v(s, "text", b.target.value),
                  rows: 3,
                  className: `l500-multi-testimonial__textarea${N?.text ? " l500-multi-testimonial__textarea--error" : ""}`
                }
              )
            ]
          },
          s
        );
      }),
      /* @__PURE__ */ r("button", { type: "button", className: "l500-multi-testimonial__add-btn", onClick: g, children: l })
    ] });
  }
}
function je() {
  ee.Instance.registerQuestion("multi-testimonial", (e) => H(Ne, e));
}
const we = "_root_1f9ho_5", Ee = "_button_1f9ho_14", xe = "_flag_1f9ho_32", ze = "_label_1f9ho_37", Se = "_buttonActive_1f9ho_41", Ae = "_buttonInactive_1f9ho_48", P = {
  root: we,
  button: Ee,
  flag: xe,
  label: ze,
  buttonActive: Se,
  buttonInactive: Ae
}, Te = [
  { code: "en", label: "English", flag: "🇬🇧" },
  { code: "es", label: "Español", flag: "🇪🇸" },
  { code: "fr", label: "Français", flag: "🇫🇷" },
  { code: "de", label: "Deutsch", flag: "🇩🇪" },
  { code: "zh-cn", label: "中文", flag: "🇨🇳" },
  { code: "pt", label: "Português", flag: "🇵🇹" },
  { code: "pl", label: "Polski", flag: "🇵🇱" },
  { code: "it", label: "Italiano", flag: "🇮🇹" },
  { code: "nl", label: "Nederlands", flag: "🇳🇱" }
];
function Ce({ value: e, onChange: t }) {
  return /* @__PURE__ */ r("div", { className: P.root, children: Te.map(({ code: n, label: i, flag: d }) => {
    const u = n === e, l = `${P.button} ${u ? P.buttonActive : P.buttonInactive}`;
    return /* @__PURE__ */ y(
      "button",
      {
        type: "button",
        onClick: () => t(n),
        className: l,
        title: i,
        "aria-pressed": u,
        children: [
          /* @__PURE__ */ r("span", { "aria-hidden": !0, className: P.flag, children: d }),
          /* @__PURE__ */ r("span", { className: P.label, children: i })
        ]
      },
      n
    );
  }) });
}
const ae = /\{(\w+)\}/g;
function ie(e, t) {
  return Object.hasOwn(e, t);
}
function at(e, t) {
  return e.replace(
    ae,
    (n, i) => ie(t, i) ? t[i] : n
  );
}
function Le(e, t) {
  const n = [];
  let i = 0;
  for (const d of e.matchAll(ae)) {
    const [u, l] = d, m = d.index;
    m > i && n.push(e.slice(i, m)), n.push(
      ie(t, l) ? H(se, { key: `${l}-${m}` }, t[l]) : u
    ), i = m + u.length;
  }
  return i < e.length && n.push(e.slice(i)), n;
}
const Me = "_root_9zuys_6", Re = "_value_9zuys_22", Q = {
  root: Me,
  value: Re
};
function Pe({
  locale: e,
  barristerName: t,
  firmName: n,
  practiceAreaName: i,
  practiceAreaNameTranslated: d
}) {
  const u = d?.trim(), l = e !== "en" && u ? u : i, m = Le(w(e).barristerIntro, {
    barristerName: /* @__PURE__ */ r("strong", { className: Q.value, children: t }),
    firmName: /* @__PURE__ */ r("strong", { className: Q.value, children: n }),
    practiceArea: /* @__PURE__ */ r("strong", { className: Q.value, children: l })
  });
  return /* @__PURE__ */ r("p", { className: Q.root, children: m });
}
const Ie = "_skeleton_2vdx1_7", Ve = "_skeletonItem_2vdx1_15", Fe = "_languageBar_2vdx1_33", Be = "_errorAlertContainer_2vdx1_46", qe = "_errorAlert_2vdx1_46", De = "_errorAlertText_2vdx1_67", Oe = "_submittedContainer_2vdx1_72", $e = "_submittedTitle_2vdx1_82", Qe = "_submittedDescription_2vdx1_89", k = {
  skeleton: Ie,
  skeletonItem: Ve,
  languageBar: Fe,
  errorAlertContainer: Be,
  errorAlert: qe,
  errorAlertText: De,
  submittedContainer: Oe,
  submittedTitle: $e,
  submittedDescription: Qe
};
ge();
je();
const K = ["en", "es", "fr", "de", "zh-cn", "pt", "pl", "it", "nl"], Ue = {
  themeName: "default",
  colorPalette: "light",
  isPanelless: !1,
  cssVariables: {
    // Typography
    "--sjs-font-family": "'ff-real-text-pro-2', 'ff-real-text-pro', sans-serif",
    "--sjs-font-questiontitle-size": "15px",
    "--sjs-font-questiontitle-weight": "500",
    "--sjs-font-questiontitle-color": "rgba(8, 37, 54, 1)",
    "--sjs-font-questiondescription-size": "13px",
    "--sjs-font-questiondescription-color": "rgba(100, 120, 134, 1)",
    "--sjs-font-editorfont-color": "rgba(8, 37, 54, 1)",
    "--sjs-font-pagetitle-family": "'ff-real-headline-pro-2', 'ff-real-headline-pro', sans-serif",
    "--sjs-font-pagetitle-size": "18px",
    "--sjs-font-pagetitle-weight": "600",
    "--sjs-font-pagetitle-color": "rgba(8, 37, 54, 1)",
    "--sjs-font-surveytitle-size": "20px",
    "--sjs-font-surveytitle-weight": "600",
    // Spacing
    "--sjs-base-unit": "7px",
    "--sjs-corner-radius": "6px",
    "--sjs-questionpanel-cornerRadius": "10px",
    "--sjs-questionpanel-hpadding": "28px",
    "--sjs-questionpanel-vpadding": "24px",
    // Primary accent
    "--sjs-primary-backcolor": "rgba(69, 60, 240, 1)",
    "--sjs-primary-backcolor-light": "rgba(69, 60, 240, 0.1)",
    "--sjs-primary-backcolor-dark": "rgba(58, 52, 196, 1)",
    // Backgrounds
    "--sjs-general-backcolor-dim": "rgba(244, 247, 250, 1)",
    "--sjs-general-backcolor-dim-dark": "rgba(237, 241, 245, 1)",
    "--sjs-editor-background": "rgba(244, 247, 250, 1)",
    "--sjs-editorpanel-backcolor": "rgba(244, 247, 250, 1)",
    // Text
    "--sjs-general-forecolor": "rgba(60, 87, 104, 1)",
    "--sjs-general-forecolor-light": "rgba(100, 120, 134, 1)",
    // Borders
    "--sjs-border-default": "rgba(207, 213, 220, 1)",
    "--sjs-border-light": "rgba(223, 229, 234, 1)",
    // Shadows
    "--sjs-shadow-small": "0px 1px 3px 0px rgba(0, 0, 0, 0.08)",
    "--sjs-shadow-small-reset": "0px 0px 0px 0px rgba(0, 0, 0, 0)",
    "--sjs-shadow-inner": "none",
    "--sjs-shadow-inner-reset": "none"
  }
};
function Ge() {
  return /* @__PURE__ */ y("div", { className: k.skeleton, children: [
    /* @__PURE__ */ r("div", { className: k.skeletonItem }),
    /* @__PURE__ */ r("div", { className: k.skeletonItem }),
    /* @__PURE__ */ r("div", { className: k.skeletonItem }),
    /* @__PURE__ */ r("div", { className: k.skeletonItem })
  ] });
}
function it({
  definition: e,
  onSubmitAction: t,
  onValidateBeforeSubmit: n,
  labels: i,
  showLanguageSelector: d,
  onLocaleChange: u,
  controlledLocale: l,
  initialLocale: m,
  barristerIntro: g,
  initialData: _,
  onDataChange: v,
  renderSubmitted: o
}) {
  const [s, N] = V(!1), [b, F] = V("en"), [B, G] = V(!1), [A, D] = V(null), f = S(b), L = S(null), E = S(u), O = S(t), q = S(n), $ = S(v), W = S(_), M = S(!1);
  j(() => {
    E.current = u;
  }, [u]), j(() => {
    O.current = t;
  }, [t]), j(() => {
    q.current = n;
  }, [n]), j(() => {
    $.current = v;
  }, [v]), j(() => {
    const a = m?.toLowerCase(), z = navigator.language.toLowerCase(), h = a && K.includes(a) ? a : K.find(
      (x) => z === x || z.startsWith(x + "-")
    ) ?? "en";
    F(h), f.current = h, N(!0), E.current?.(h);
  }, []);
  const c = U(
    async (a, z) => {
      if (z.allowComplete = !1, M.current || (D(null), !(q.current?.() ?? !0))) return;
      const x = a.getAllQuestions().filter((C) => !C.readOnly);
      M.current = !0, x.forEach((C) => {
        C.readOnly = !0;
      }), a.completeText = w(f.current).submitting;
      let T;
      try {
        T = await O.current(a.data, f.current);
      } catch (C) {
        console.error("Survey submit failed", C), T = { success: !1, error: w(f.current).submitServerError };
      }
      M.current = !1, x.forEach((C) => {
        C.readOnly = !1;
      }), a.completeText = w(f.current).submitButton, T.success ? (G(!0), window.scrollTo({ top: 0, behavior: "smooth" })) : D(T.error);
    },
    []
  ), p = le(() => {
    const a = new ce(e);
    a.questionsOnPageMode = "singlePage", a.applyTheme(Ue), a.widthMode = "responsive", a.width = "100%", a.locale = b, a.completeText = w(b).submitButton, a.onCompleting.add(c), W.current && (a.mergeData(W.current), a.clearIncorrectValues(!0)), a.onValueChanged.add((h) => {
      $.current?.(h.data);
    });
    const z = a.tryComplete.bind(a);
    return a.tryComplete = () => M.current || !(q.current?.() ?? !0) ? !1 : z(), a.onValidateQuestion.add((h, x) => {
      if (x.question.getType() !== "multi-testimonial") return;
      const T = ke(x.value, h.locale);
      T && (x.error = T);
    }), a.getAllQuestions().forEach((h) => {
      h.getType() === "boolean" && (h.swapOrder = !0);
    }), a;
  }, [c]), R = U(
    (a) => {
      F(a), f.current = a, p.locale = a, p.completeText = w(a).submitButton, E.current?.(a);
    },
    [p]
  );
  if (j(() => {
    l !== void 0 && s && l !== f.current && R(l);
  }, [l, s, R]), j(() => {
    s && (p.locale = b, p.completeText = w(b).submitButton);
  }, [p, b, s]), j(() => {
    A && L.current && L.current.scrollIntoView({ behavior: "smooth", block: "center" });
  }, [A]), B) {
    if (o) return o(b);
    const a = w(b), z = i?.submittedTitle ?? a.submittedTitle, h = i?.submittedDescription ?? a.submittedDescription;
    return /* @__PURE__ */ y("div", { className: k.submittedContainer, children: [
      /* @__PURE__ */ r("p", { className: k.submittedTitle, children: z }),
      h ? /* @__PURE__ */ r("p", { className: k.submittedDescription, children: h }) : null
    ] });
  }
  return s ? /* @__PURE__ */ y("div", { children: [
    d !== !1 && /* @__PURE__ */ r("div", { className: k.languageBar, children: /* @__PURE__ */ r(Ce, { value: b, onChange: R }) }),
    g ? /* @__PURE__ */ r(Pe, { locale: b, ...g }) : null,
    /* @__PURE__ */ r("div", { ref: L, role: "alert", "aria-live": "polite", className: k.errorAlertContainer, children: A && /* @__PURE__ */ r("div", { className: k.errorAlert, children: /* @__PURE__ */ r("span", { className: k.errorAlertText, children: A }) }) }),
    /* @__PURE__ */ r(ue, { model: p })
  ] }) : /* @__PURE__ */ r(Ge, {});
}
const We = "_root_ykgex_6", He = "_eyebrow_ykgex_24", Ye = "_heading_ykgex_35", Je = "_subtitle_ykgex_51", Ke = "_separator_ykgex_60", I = {
  root: We,
  eyebrow: He,
  heading: Ye,
  subtitle: Je,
  separator: Ke
};
function ot({
  publication: e,
  practiceArea: t,
  firmName: n,
  eyebrow: i,
  region: d,
  children: u
}) {
  return /* @__PURE__ */ y("div", { className: I.root, children: [
    /* @__PURE__ */ r("span", { className: I.eyebrow, children: i }),
    /* @__PURE__ */ r("h1", { className: I.heading, children: n }),
    /* @__PURE__ */ y("p", { className: I.subtitle, children: [
      t,
      d ? /* @__PURE__ */ y(oe, { children: [
        /* @__PURE__ */ r("span", { className: I.separator, children: "·" }),
        d
      ] }) : null,
      /* @__PURE__ */ r("span", { className: I.separator, children: "·" }),
      e
    ] }),
    u
  ] });
}
export {
  Pe as BarristerIntro,
  Ce as LanguageSelector,
  J as NO_EXPERIENCE_VALUE,
  me as NumericRadioChoice,
  it as SurveyForm,
  ot as SurveyHeader,
  w as getSurveyT,
  at as interpolate,
  Le as interpolateNodes,
  je as registerMultiTestimonial,
  ge as registerRangeQuestion,
  ke as validateMultiTestimonialEntries
};
